/*!

=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import { AuthContext } from "contexts/AuthContext";
import React, { useContext } from "react";

// reactstrap components
import { Container, Nav, NavItem, NavLink } from "reactstrap";

function Footer() {
  const [auth] = useContext(AuthContext);
  return (
    <footer className="footer">
      <Container fluid>
        <div style={{padding: "0 24px",}}>
          <span style={{marginRight: 64}} color="green">Whatsapp Status: {auth.whatsapp.status}</span>
          <span color="green">State: {auth.whatsapp.state}</span>
        </div>
        <div className="copyright">
          © Todos os Direitos Reservados.
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
